export var chartColors = [
    '#247D63',
    '#1DCF9A',
    '#BEEADD',
    '#286B79',
    '#1DB1CF',
    '#8FD86B'
];
